export class Cualidades {
  public Nombre: string;
  public Nivel: string;
  public id: number;

  constructor() {  }

}